// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCarousel":"styles_componentsMapCarousel__1Tu08","carousel":"styles_carousel__LerUx","merchantName":"styles_merchantName__1uTME","btn":"styles_btn__1uZG-"};